import * as React from 'react';
import { useSelector } from 'react-redux';

import { TFeature } from '../../../../../../common/types/map';
import { IApplicationState } from '../../../../../../common/types/redux';
import { useFavoritesSubscriber, EFavoriteAction } from '../../../../../../common/utils/favorites';
import { selectActiveFeature } from '../../../../../selectors';
import { useMapContext } from '../../../context';
import { useFeaturesContext } from '../context';

export const FavoritesUpdater: React.FC = () => {
  const { map } = useMapContext();
  const { rbush } = useFeaturesContext();
  const lastFavoritesAction = useFavoritesSubscriber();
  const selectedFeature = useSelector<IApplicationState, TFeature | null>(selectActiveFeature);

  React.useEffect(() => {
    if (!selectedFeature || !lastFavoritesAction) {
      return;
    }

    const bounds = map.getBounds();
    const featuresInBbox = rbush.search({
      minX: bounds[0][0],
      minY: bounds[0][1],
      maxX: bounds[1][0],
      maxY: bounds[1][1],
    });

    const wantedRbushItem = featuresInBbox.find(rbushItem => rbushItem.feature.id === selectedFeature.id);

    if (!wantedRbushItem) {
      return;
    }

    const { feature } = wantedRbushItem;

    if (lastFavoritesAction.action === EFavoriteAction.Added) {
      feature.properties.offers = feature.properties.offers.map(offer =>
        offer.realtyId === lastFavoritesAction.offerId ? { ...offer, isFavorite: true } : offer,
      );
    } else {
      feature.properties.offers = feature.properties.offers.map(offer =>
        offer.realtyId === lastFavoritesAction.offerId ? { ...offer, isFavorite: false } : offer,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastFavoritesAction]);

  return null;
};
